export default __webpack_public_path__ + "static/media/youtube_music.769059b7.png";